<template>
  <div class="product-container" :class="{ slider: isSlider }" @click="selectProduct(product)">
    <div class="product-image-container">
      <img class="main-image" width="280" height="280" loading="lazy" :src="product | getProductImage">
      <p v-if="isPreorder" class="preorder-tag lh-1 rounded-sm body-small pd-05rem font-bold bg-pink color-link flex flex-align-center gap-05vw">
            <img src="https://cdn.shopify.com/s/files/1/1363/8433/files/Preorder.svg?v=1754334770" width="15" height="15" alt="preorder" class="preorder-tag-icon">
            <span class="preorder-tag-text color-link lh-1">Available for Preorder</span>
        </p>
    </div>
    <button class="hb-btn secondary" :class="{ 'body-small': isSlider }" @click="selectProduct(product)">
      {{ buttonText }}
    </button>
    <p class="title">{{ product.title }}</p>
    <div class="product-price-container">
      <span v-if="product.variants.find(x => x.price != '' && x.price != '0.00').compare_at_price" class="discount-price">
        {{ product.variants.find(x => x.price != '' && x.price != '0.00').compare_at_price | moneySaleFormat }}
      </span>
      <span class="price">{{ product | moneyFormat }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProductCard',
  props: {
    product: {
      type: Object,
      required: true
    },
    isSlider: {
      type: Boolean,
      default: false
    },
    buttonText: {
      type: String,
      default: 'Add to cart'
    }
  },
  computed: {
    isPreorder() {
      return this.product.tags.some(x => x.includes("preorder"));
    }
  },
  methods: {
    selectProduct(product) {
      this.$emit('select-product', product);
    }
  }
}
</script>

<style scoped>
.product-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  height: 100%;
}

.product-container .product-image-container {
  width: 100%;
  position: relative;
  overflow: hidden;
  display: flex;
  margin-bottom: 0.5rem;
}

.product-container .product-image-container .main-image {
  width: 100%;
  background-color: #F6F6F6;
  cursor: pointer;
  height: 100%;
  aspect-ratio: 1;
  object-fit: cover;
}

.product-container .title {
  font-weight: 700;
  font-size: 1.1vw;
  line-height: 1.5;
  margin-top: 2%;
  margin-bottom: 0;
}

.product-container .product-price-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  font-size: 1vw;
  line-height: 1.43;
  padding-bottom: 5%;
}

.product-container .product-price-container .price {
  color: #3F3D60;
}

.product-container .product-price-container .discount-price {
  color: red;
  text-decoration: line-through;
  padding-right: 5%;
}

.preorder-tag{
  position: absolute;
  top: 5%;
  left: 5%;
  z-index: 1;
}

/* Mobile styles */
@media only screen and (max-device-width: 767px) {
  .product-container .title,
  .product-container .product-price-container {
    font-size: 1rem;
    line-height: 1.2;
  }

  .product-container.slider {
    background-color: white;
    border-radius: 8px;
    border: 1px solid black;
    padding-bottom: 5%;
    position: relative;
  }

  .product-container.slider .happybox-button {
    width: 90%;
    padding: 0.2rem 0;
    margin-left: 5%;
    font-size: 2vw;
  }

  .product-container.slider .product-image-container .main-image {
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
  }

  .product-container.slider .title,
  .product-container.slider .product-price-container {
    padding: 0% 5%;
    font-size: 2.8vw;
  }
}
</style>
